import { makeV2APIURL } from '^/store/duck/API';
import { useReactQuery } from '^/utilities/api';
import { AddProject, APIToProjectWithConfig } from '^/store/duck/Projects';
import _ from 'lodash-es';
import * as T from '^/types';
import { useDispatch } from 'react-redux';

export const queryKey = 'project-detail';
interface ProjectResponseDetails {
  data: T.APIProject;
  status: {
    code: number;
  };
}
export const useGetProjectDetail = ({
  projectId = '',
  hasProject = false,
}: {
  projectId?: string;
  hasProject?: boolean;
}) => {
  const dispatch = useDispatch();
  const url = projectId ? makeV2APIURL('projects', projectId) : '';

  const {
    data: projectData,
    isLoading,
    refetch,
  } = useReactQuery({
    endpoint: url,
    axiosOptions: {},
    queryKey: [`${queryKey}-${projectId}`],
    enabled: Boolean(projectId && !hasProject),
    onSuccessCallback: (data: ProjectResponseDetails) => {
      const project: T.ProjectWithConfig | undefined =
        data?.data && APIToProjectWithConfig(data.data);
      if (project) {
        dispatch(
          AddProject({
            project: _.omit(project, ['config']),
          })
        );
      }
    },
  });
  const project: T.ProjectWithConfig | undefined =
    projectData?.data && APIToProjectWithConfig(projectData.data);

  return { project, isLoading, refetch };
};
